import { Component, OnDestroy, Input } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { CartService } from '@core/services/cart/cart.service';
import { PonchoUIModule } from '@poncho/ui';
import { MultiBrandCartViewComponent } from '../../../../../shared/components/multi-brand-cart-view/multi-brand-cart-view.component';
import { MatMenuModule } from '@angular/material/menu';

@Component({
    selector: 'app-cart-dropdown',
    templateUrl: './cart-dropdown.component.html',
    styleUrls: ['./cart-dropdown.component.scss'],
    standalone: true,
    imports: [MatMenuModule, MultiBrandCartViewComponent, PonchoUIModule]
})

export class CartDropdownComponent implements OnDestroy {

    total_quantity = 0;
    displayCartCount = '';
    total_price = 0;
    submitCartInProgress = false;
    destroySubject$: Subject<void> = new Subject();
    @Input()showCartDropDown = false;

    constructor(
        private cartService: CartService
    ) {
        this.cartService.state
            .pipe(takeUntil(this.destroySubject$))
            .subscribe((cart: any) => {
                const cart_items = Object.values(cart.items);
                this.total_quantity = cart_items.reduce((acc: number, item: any) => acc + item.quantity, 0) as number;
                this.displayCartCount = String(this.total_quantity);
                if(this.total_quantity > 9) {
                    this.displayCartCount = '9+';
                }
                this.total_price = cart_items.reduce((acc: number, item: any) => acc + item.price * item.quantity, 0) as number;
            });
    }

    ngOnDestroy() {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    }

    submitCart() {
        this.submitCartInProgress = true;
        this.cartService.submitCart()
            .finally(() => {
                this.submitCartInProgress = false;
            });
    }
}
